import { apiClient } from 'client/core/network/apiClient';
import { IDashboardData } from 'common/schema/Dashboard';

export const DashboardApi = {
  getData: () => apiClient.get<IDashboardData>(`/dashboard/data`)
};
